import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { SelectInput } from '../core/components/forms';
import Form from '../core/components/forms/Form';
import * as actions from './store/actions';
import Can from '../permissions/abilities/Can';

// interface CarmenVehicleSelectProps {
//   carmenMake?: object
//   makes?: unknown[]
//   updateCarmenMake?(...args: unknown[]): unknown
// }

const CarmenVehicleSelect = props => {
  const { makes, carmenMake, updateCarmenMake } = props;

  const [loading, setLoading] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);

  const handleSubmit = async (id, value) => {
    setLoading(true);
    await updateCarmenMake(id, { vehicleMakeId: value });
    setShowCloseButton(!isEmpty(value));
    setLoading(false);
  };

  useEffect(() => {
    if (carmenMake.vehicleMakeId) {
      setShowCloseButton(true);
    }
  }, [carmenMake.vehicleMakeId]);

  return (
    <Form
      initialValues={ { vehicleMakeId: carmenMake.vehicleMakeId } }
      onSubmit={ handleSubmit }
    >
      { ({ values, handleChange }) => (
        <Can do='permissionUpdate' on='reference.carmen.makes' passThrough>
          { can => (
            <SelectInput
              name='vehicleMakeId'
              placeholder='Марка'
              data={ makes }
              dataTitle='title'
              dataValue='id'
              loading={ loading }
              onChange={ async e => {
                handleChange(e);
                await handleSubmit(carmenMake.id, e.target.value);
              } }
              isClearable={ showCloseButton }
              isDisabled={ !can }
              className={ !values.vehicleMakeId ? 'unselected' : null }
            />
          ) }
        </Can>
      ) }
    </Form>

  );
};

const mapDispatchToProps = dispatch => ({
  updateCarmenMake: (id, data) => dispatch(actions.updateCarmenMake(id, data)),
});

export default connect(null, mapDispatchToProps)(CarmenVehicleSelect);
